/**
 * IM 消息处理函数统一导出
 *
 * 职责：
 * 1. 导出所有消息类型的处理函数
 * 2. 提供消息处理器的注册和注销配置
 */

import { handlePrivateMessages } from './privateMessages'
import { handleToast, handleNotice } from './notifications'
import {
  handleVideoCallInvite,
  handleVideoCallJoin,
  handleVideoCallRefuse,
  handleVideoCallHangUp,
  handleVidelCallMessages,
  handleVideoCallGiftMessages,
  handleVideoCallSystemNotice,
  handleMsgInsteadVideoPop,
  handleLoveRoomVideoPop
} from './videoCall'
import { handleSyncCoin, handleVipChange, handleSignoutRemind } from './userStatus'
import { IMCustomMsgType } from '@/common/constants/imCustomMsgTypes'

/**
 * 消息处理器配置
 * 每个配置项包含：
 * - msgType: 消息类型（来自 IMCustomMsgType）
 * - handler: 对应的处理函数
 * - description: 描述信息（用于调试和文档）
 */
export const messageHandlers = [
  // 私聊消息
  {
    msgType: IMCustomMsgType.PUSH_MSG,
    handler: handlePrivateMessages,
    description: '私聊消息（包含 MsgBean）',
  },

  // Toast 和通知
  {
    msgType: IMCustomMsgType.TOAST_COMMON,
    handler: handleToast,
    description: '通用 Toast 提示',
  },
  {
    msgType: IMCustomMsgType.COMMON_NOTICE,
    handler: handleNotice,
    description: '统一通知消息',
  },

  // 视频通话相关
  {
    msgType: IMCustomMsgType.LOVE_ROOM_INVITE,
    handler: handleVideoCallInvite,
    description: '视频通话 - 收到邀请',
  },
  {
    msgType: IMCustomMsgType.LOVE_ROOM_JOIN,
    handler: handleVideoCallJoin,
    description: '视频通话 - 对方接听/随机匹配成功',
  },
  {
    msgType: IMCustomMsgType.LOVE_ROOM_REFUSE,
    handler: handleVideoCallRefuse,
    description: '视频通话 - 对方拒绝',
  },
  {
    msgType: IMCustomMsgType.LOVE_ROOM_HANG_UP,
    handler: handleVideoCallHangUp,
    description: '视频通话 - 挂断（包括服务端主动挂断）',
  },

  // 用户状态相关
  {
    msgType: IMCustomMsgType.SYNC_COIN,
    handler: handleSyncCoin,
    description: '金币同步 - 刷新用户资产',
  },
  {
    msgType: IMCustomMsgType.VIP_CHANGE,
    handler: handleVipChange,
    description: 'VIP 状态变更 - 刷新用户信息',
  },
  {
    msgType: IMCustomMsgType.SIGNOUT_REMIND,
    handler: handleSignoutRemind,
    description: '账号注销提醒 - 强制退出登录',
  },

  // 直播间消息
  {
    msgType: IMCustomMsgType.LOVE_ROOM_MESSAGE,
    handler: handleVidelCallMessages,
    description: '直播间消息 - 1v1视频通话中的文字消息',
  },

  // 视频通话系统通知
  {
    msgType: IMCustomMsgType.VIDEO_CALL_MSG_NOTICE,
    handler: handleVideoCallSystemNotice,
    description: '视频通话系统通知 - 合规警告和用户引导消息',
  },

  // 礼物赠送
  {
    msgType: IMCustomMsgType.SEND_GIFT,
    handler: handleVideoCallGiftMessages,
    description: '礼物赠送消息 - 1v1视频通话中的礼物消息',
  },

  // 消息替代视频弹窗
  {
    msgType: IMCustomMsgType.MSG_INSTEAD_VIDEO_POP,
    handler: handleMsgInsteadVideoPop,
    description: '消息替代视频弹窗 - 引导用户发起视频通话',
  },

  // 视频弹窗
  {
    msgType: IMCustomMsgType.LOVE_ROOM_VIDEO_POP,
    handler: handleLoveRoomVideoPop,
    description: '视频弹窗 - 引导用户发起视频通话',
  },
]

// 导出处理函数（便于测试和直接引用）
export {
  // 私聊消息
  handlePrivateMessages,

  // Toast 和通知
  handleToast,
  handleNotice,

  // 视频通话
  handleVideoCallInvite,
  handleVideoCallJoin,
  handleVideoCallRefuse,
  handleVideoCallHangUp,

  // 用户状态
  handleSyncCoin,
  handleVipChange,
  handleSignoutRemind,

  // 直播间消息
  handleVidelCallMessages,

  // 视频通话系统通知
  handleVideoCallSystemNotice,

  // 礼物赠送
  handleVideoCallGiftMessages,

  // 消息替代视频弹窗
  handleMsgInsteadVideoPop,

  // 视频弹窗
  handleLoveRoomVideoPop,
}
